// /src/lists/noticias.ts

export interface NoticiaItem {
  icon?: string;
  title: string;
  description: string;
  url?: string | null;
}

export const noticias: NoticiaItem[] = [
  {
    icon: "📄",
    title: "Protocolo de desconexión digital: ¿es realmente obligatorio?",
    description: "Elaboramos el protocolo sin coste para asociados",
    url: null,
  },
  {
    icon: "📊",
    title:
      "Formación bonificada FUNDAE: aprovecha tus créditos antes de que caduquen",
    description: "Mejora tu empresa y forma a tus trabajadores sin coste.",
    url: null,
  },
  {
    icon: "🔔",
    title: "ISO 9001 e ISO 14001: la clave para licitar con ventaja",
    description:
      "Más puntos, más confianza y más oportunidades en licitaciones públicas",
    url: null,
  },
  {
    icon: "💼",
    title: "Licita en Portugal ",
    description: "Amplía tus oportunidades de negocio internacional",
    url: null,
  },
  {
    icon: "🏆",
    title: "Clasificación empresarial: ¿qué beneficios aporta a tu negocio?",
    description:
      "Clasificación empresarial: ¿qué beneficios aporta a tu negocio?",
    url: null,
  },
];
